"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const transactionSigningSelector_1 = require("@/features/transaction-signing/selectors/transactionSigningSelector");
//import { FormattedMessage, injectIntl, useIntl, WrappedComponentProps } from 'react-intl'
const react_intl_1 = require("react-intl");
const react_design_system_1 = require("@hdh-core/react-design-system");
const transactionSigningAction_1 = require("../actions/transactionSigningAction");
const TransactionSigningOneToken = ({ onClose }) => {
    const { showTransactionSiginingOneToken, expirySecs } = (0, react_redux_1.useSelector)(transactionSigningSelector_1.transactionSigningSelector);
    const dispatch = (0, react_redux_1.useDispatch)();
    const intl = (0, react_intl_1.useIntl)();
    //const [isOpen, setOpen] = useState(true)
    const [isOpen] = (0, react_1.useState)(true);
    const [startTimer, setStartTime] = (0, react_1.useState)(false);
    //const [resendMessage, setResendMessage] = useState(false)
    const [timer, setTimer] = (0, react_1.useState)(expirySecs);
    (0, react_1.useEffect)(() => {
        //NOSONAR
        if (startTimer) {
            const intervalId = setInterval(() => {
                setTimer(t => t - 1);
            }, 1000);
            if (timer <= 0) {
                clearInterval(intervalId);
                //setResendMessage(true)
            }
            return () => clearInterval(intervalId);
        }
        return null;
    }, [timer, startTimer]);
    const handleToggleCloseOneToken = () => {
        console.log('handleToggleCloseOneToken');
        setStartTime(false);
        dispatch((0, transactionSigningAction_1.endAuthorizationStatus)());
        dispatch((0, transactionSigningAction_1.toggleCloseOneToken)());
        onClose();
    };
    const handleToggleSWKResendNotification = () => {
        console.log('handleToggleResendNotification');
        dispatch((0, transactionSigningAction_1.toggleSWKResendNotification)());
        setTimer(expirySecs);
        //setResendMessage(false)
    };
    //const handleToggleGenerateOtp = () => {
    //	console.log('handleToggleGenerateOtp')
    //	dispatch(toggleGenerateOtp())
    //}
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_design_system_1.ConfirmDialog, { isOpen: isOpen, setOpen: showTransactionSiginingOneToken, title: intl.formatMessage({ id: 'transaction-signing-soft-token-title' }), iconType: "soft-token", message: intl.formatMessage({ id: 'transaction-signing-msg' }), leftBtnLabel: intl.formatMessage({ id: 'common.button.btnCancel' }), onCancelClick: handleToggleCloseOneToken, rightBtnLabel: intl.formatMessage({ id: 'common.button.btnResend' }), onConfirmClick: handleToggleSWKResendNotification, rightBtnDisabled: timer !== 0, hasTimer: true, timerLabel: intl.formatMessage({ id: 'transaction-signing-timeRemaining' }), timerCounter: timer + intl.formatMessage({ id: 'transaction-signing-second' }), hasResendMessage: true, isResendMessageInReactNode: true, resendNotificationMessage: react_1.default.createElement(react_design_system_1.Box, { className: "rds-text-center" },
                react_1.default.createElement(react_design_system_1.Text, { className: "rds-text-sm rds-text-center", isHTMLTextFormatting: true, htmlText: intl.formatMessage({ id: 'transaction-signing-notReceivedNotification' }) })) }),
        !startTimer ? setStartTime(true) : null));
};
exports.default = TransactionSigningOneToken;
